import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-terms-page',
    templateUrl: './terms-page.component.html',
    styleUrls: ['./terms-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TermsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
